import React, { createContext, useContext, useState } from 'react';
import { themes } from '../config/themes';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
    const [themeName, setThemeName] = useState(
        () => localStorage.getItem('sitetheme') || 'light'
    );

    const theme = themes[themeName] || themes.light;

    const toggleTheme = () => {
        const next = themeName === 'light' ? 'dark' : 'light';
        setThemeName(next);
        localStorage.setItem('sitetheme', next);
    };

    return (
        <ThemeContext.Provider value={{ theme, themeName, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
    return ctx;
}
